import React from 'react';
import { Div, Label, Select } from "@grassrootly/rn-core";
import { SeasonOption } from './useSeasonSelector';

interface SeasonSelectorProps {
  seasonOptions: SeasonOption[];
  selectedSeasonId?: number;
  onSeasonChange: (seasonId: number | undefined) => void;
  loading?: boolean;
}

export default function SeasonSelector({ 
  seasonOptions, 
  selectedSeasonId, 
  onSeasonChange, 
  loading 
}: SeasonSelectorProps) {
  // Don't render the component if there are no seasons available
  if (loading || seasonOptions.length === 0) {
    return null;
  }

  // Convert season options to Select format with organization logos
  const selectOptions = [
    { label: "Select season (optional)", value: "", icon: undefined },
    ...seasonOptions.map(option => ({
      label: option.label,
      value: option.value.toString(),
      icon: option.icon
    }))
  ];

  const selectedValue = selectedSeasonId ? selectedSeasonId.toString() : "";

  const handleSelect = (item: any) => {
    const seasonId = item.value && item.value !== "" ? parseInt(item.value, 10) : undefined;
    onSeasonChange(seasonId);
  };

  return (
    <Div classNames={["mt-{16}", "mb-{8}"]}>
      <Label type="l3Bold" classNames={["mb-{8}"]}>Season</Label>
      <Select
        options={selectOptions as any}
        selectedOption={selectedValue}
        onSelect={handleSelect}
        placeholderText="Select season (optional)"
        forceSelectedOption
      />
    </Div>
  );
}
